import React from 'react';
import {
  VStack,
  FormControl,
  Button,
  FormLabel,
  FormErrorMessage
} from '@chakra-ui/react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const PhoneInputSection = ({ value, onChange, error, onNext }) => (
  <VStack spacing={3} mb={2} align="stretch">
    <FormControl isInvalid={!!error}>
      <FormLabel fontWeight="medium" color="gray.700" mb={1}>
        Phone No
      </FormLabel>
      <PhoneInput
        country={'bd'}
        value={value}
        onChange={onChange}
        inputStyle={{
          width: '100%',
          height: '48px',
          fontSize: '16px',
          borderRadius: '8px',
          border: '1px solid #E2E8F0',
          paddingLeft: '48px',
        }}
        buttonStyle={{ border: 'none', background: 'none' }}
        placeholder="Enter your phone number"
        masks={{ bd: '(...) ......' }}
      />
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
    <Button colorScheme="blue" size="lg" w="full" onClick={onNext}>
      Next
    </Button>
  </VStack>
);

export default PhoneInputSection; 